<template>
  <div class="wrapper-header-form">
		<div class="pros-header">
			<div class="pros-header-logo">Adult Learn To Play</div>
			<div class="pros-nav">
				<!-- <span class="pro-number">555.555.5555</span> I wasn't sure if this was needed. If not, please remove.-->
				<a class="btn-gen-header" href="javascript:void">Back to home</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  name: 'FormHeader',
  data() {
    return {
      title: '',
      phone: ''
    }
  }
}
</script>

<style scoped>
  body {margin: 0;padding: 0;font-family: 'Open Sans', Helvetica, Arial, sans-serif;font-size: 16px;background: #fff;}
  .wrapper-body-home {background: url(~@/assets/altp-bg-text.png) no-repeat center bottom, url(~@/assets/altp-bg01.jpg) no-repeat center center;background-size: contain, cover;}
  .pros-header {padding: 20px 0;margin: 0 auto;max-width: 1440px;overflow: hidden;}
  .pros-header-logo {display: block;width: 140px; height: 140px; text-indent: -9999px;background: url(~@/assets/altp-logo.png) no-repeat center center;background-size: contain;float: left;}
  .pros-nav {display: block;color: #fff;font-size: 1em; font-weight: bold;float: right;}
  .pros-nav .btn-gen-header {display: inline-block;text-decoration: none;text-transform: uppercase;padding: 10px 15px;background-color: #041e42; background-color: rgba(4,30,66,.7);border-radius: 20px;color: #fff;font-style: italic;margin-left: 10px;}
  .pros-nav .btn-gen-header:hover {background-color: #c8102e;background-color: rgba(200,16,46,.7);}
  .pros-footer {background: #fff;font-size: .75em; padding: 20px;color: #666;text-align: center;}
  .pros-footer .pros-footer-logo {width: 70px;display: inline-block;margin-right: 10px;vertical-align: top;}
  .pros-footer .pros-footer-logo img {max-width: 100%;}
  .pros-footer .pros-footer-colophon {display: inline-block;max-width: 80%;text-align: left;}
  .pros-content {margin: 40px auto;max-width: 960px;padding: 20px;}
  .wrapper-header-form {background-color: #c8102e; background: url(~@/assets/altp-bg02.jpg) no-repeat center center #c8102e;background-size: cover;margin-bottom: 5px;box-shadow: 1px 0px 3px rgba(0,0,0,.5);}

  @media only screen and (min-width:1440px) {
  .wrapper-body-home {min-height: 800px;background-size: 1166px 83px, cover;}
  .wrapper-header-form {background-position: center top;}
  }
  @media only screen and (max-width:1440px) {
  .pros-header {padding: 20px;}
  .wrapper-body-home {min-height: 600px;background-size: 90%, cover;}
  }
  @media only screen and (max-width:640px) {
  .wrapper-header-form {background-size: inherit;}
  .pros-header-logo {width: 100px;height: 100px;}
  .pros-nav {float: none;text-align: right;}
  .pro-number {display: inline-block;margin-right: 15px;}
  .pros-footer .pros-footer-logo {margin-right: 0;width: 40px;}
  .pros-footer .pros-footer-colophon {max-width: 100%;}
  }
  @media only screen and (max-width:320px) {
  .pros-header {padding: 10px;}
  .pros-header-logo {width: 80px;height: 80px;}
  .pros-nav {float: none;text-align: right;}
  .pro-number {display: inline-block;margin-right: 15px;}
  .pros-nav .btn-gen-header {margin-top: 10px;}
  }
</style>